import { render, staticRenderFns } from "./Remind.vue?vue&type=template&id=7f90ab42&"
import script from "../../models/push-notifications/remind.ts?vue&type=script&lang=ts&"
export * from "../../models/push-notifications/remind.ts?vue&type=script&lang=ts&"
import style0 from "./Remind.vue?vue&type=style&index=0&id=7f90ab42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports